import { ro } from "vuetify/lib/locale";

export default {
  $vuetify: { ...ro },
  ...ro,
  // Navigare
  navigation: {
    plantsCare: "Îngrijire plante",
    shop: "Magazin",
    collection: "Colecție",
  },

  // Header
  header: {
    // Meniu static de navigare
    menu: {
      assortment: "Sortiment",
      aboutHappyPlants: "Despre Happy Plants",
      inspiration: "Inspirație",

      homePage: {
        header: "Pagina principală",
        title: "Pagina principală",
      },
      CollectionPage: {
        header: "Toate produsele",
        title: "Toate produsele",
      },
      caringPlants: {
        header: "Îngrijirea plantelor",
        title: "Principii de îngrijire a plantelor",
      },
      ourCompany: {
        header: "Compania noastră & B2B",
        title: "Compania noastră & B2B",
      },
      santinoSystem: {
        header: "Sistemul Santino de îngrijire a plantelor",
        title: "Sistem de îngrijire a plantelor",
      },
      Contact: {
        header: "Contact",
        title: "Contactează-ne",
      },
      selfWatering: {
        header: "Ghivece cu auto-udare",
        title: "Sistemul Santino de auto-udare",
      },
      sustainability: {
        header: "Sustenabilitate",
        title: "Sustenabilitate",
      },
      blog: {
        header: "Sfaturi și consiliere pentru toți iubitorii de plante",
        title: "Citiți blogul nostru",
      },
      inspireTopics: {
        header: "Inspirați-vă cu subiecte relevante",
      },
    },

    // Meniu dinamic de categorii
    categories: {
      allProducts: "Toate produsele",
      loading: "Se încarcă categoriile...",
      shoppingCart: "Coș de cumpărături",
      goToCart: "Mergi la coș",
    },

    // Etichete Aria pentru accesibilitate
    aria: {
      logoLink: "link către pagina principală",
      searchToggle: "Comutați căutarea",
      menuToggle: "Comutați meniul de navigare",
    },
  },

  // Meniu mobil (drawer)
  mobileDrawer: {
    // Titluri ferestre
    title: {
      main: "principal",
    },

    // Meniu principal
    menu: {
      home: "acasă",
      assortment: {
        title: "sortiment",
        items: {
          allProducts: "toate produsele",
          shoppingCart: "coș de cumpărături",
        },
      },
      about: {
        title: "despre happy plants",
        items: {
          aboutUs: "Despre noi & B2B",
          sustainability: "Sustenabilitate",
          plantCare: "Principii de îngrijire a plantelor",
          santinoSystem: "Sistemul Santino de auto-udare",
          blog: "Citiți blogul nostru",
        },
      },
      inspiration: {
        title: "inspirație",
      },
      contact: "contact",
    },

    // Elemente secundare de meniu
    secondary: {
      terms: "termeni și condiții",
      privacy: "confidențialitate",
    },

    // Footer
    footer: {
      whatsapp: "WHATS APP",
      b2b: "B2B",
      contact: "CONTACTAȚI-NE",
    },
  },

  // Căutare
  searchField: {
    label: "Căutați produse",
    searching: "Se caută produse...",
    untitledProduct: "Produs fără titlu",

    // Rezultate căutare
    results: {
      title: "Rezultate căutare ({count})",
      sku: "SKU",
      currency: "EUR",
    },

    // Fără rezultate
    noResults: {
      title: "Nu s-au găsit rezultate",
      subtitle: 'Încercați să ajustați termenii de căutare pentru "{query}"',
    },

    // Căutări recente
    recent: {
      title: "Căutări recente",
    },

    // Căutări populare (exemple)
    popular: {
      selfWatering: "ghiveci cu auto-udare",
      indoorPlants: "plante de interior",
      flowerPots: "ghivece de flori",
      plantCare: "îngrijire plante",
      decorativePots: "ghivece decorative",
      outdoorPlanters: "jardiniere de exterior",
    },

    // Eroare
    error: "A apărut o eroare în timpul căutării",
  },

  // Coș de cumpărături
  shoppingCart: {
    ariaLabel: "coș de cumpărături",
    title: "Coșul dvs.",
    loading: "Se încarcă produsele...",
    empty: "Coșul dvs. este gol",
    subtotal: "Subtotal:",
    currency: "EUR",
    checkoutNote: "Prețul final va fi văzut după finalizare",
    placeOrder: "Plasați comanda",
    minimumOrder: "min. EUR",
  },

  // Pagina principală
  home: {
    subtitle: "De peste +16 ani producem",
    headline: {
      part1: "Ghivece de flori excepționale",
      part2: "cu sistem de auto-udare",
      part3: "care au grijă de plantele dvs.",
      part4: "și economisesc",
      water: "apă",
    },
    buttons: {
      plantCare: "Îngrijire plante",
      shop: "Magazin",
    },
    // Secțiune categorii
    categories: {
      title: "Descoperiți gama noastră de produse",
      subtitle: "Ghivece inteligente pentru înfloriri frumoase",
      shopAll: "Cumpărați toate",
      loading: "Se încarcă categoriile...",
    },
    // Produse populare
    popularProducts: {
      title: "Cele mai populare produse",
      subtitle: "Bestseller-uri pentru îngrijirea plantelor fără efort",
      seeAll: "Vezi toate produsele",
    },
    // Oferte speciale
    saleOffers: {
      title: "Oferte de vânzare",
      subtitle: "Bestseller-uri pentru îngrijirea plantelor fără efort",
      seeAll: "Vezi toate produsele",
    },
    // Tehnologia ghivecelor
    potsTechnology: {
      subtitle: "Tehnologia ghivecelor noastre",
      title: {
        part1: "De ce",
        plants: "plantele",
        part2: "au probleme?",
        part3: "cum am conceput o modalitate",
        smarter: "mai inteligentă",
        part4: "de a le",
        helpThemThrive: "ajuta să prospere",
      },
      buttons: {
        plantCare: "Tehnologie de îngrijire a plantelor",
        shop: "Magazin",
      },
    },
    // Problema rădăcinilor
    rootProblem: {
      title: "Ce face plantele dvs. triste?",
      paragraph1: {
        part1: "Chiar și cele mai frumoase",
        highlight: "plante de interior pot avea probleme când nevoile lor de bază nu sunt satisfăcute.",
        part2: "Și cel mai adesea, problema se reduce la un singur lucru - udarea.",
      },
      paragraph2: "Fie că sunteți un amator sau un profesionist experimentat în plante, aceste provocări pot duce la un singur lucru: o plantă nesănătoasă.",
      solutionSubtitle: "Soluția noastră inovatoare pentru plante sănătoase",
      solutionTitle: "De aceea am reimaginat ghiveciul de flori.",
      solutionText: "Plantele nu prosperă pe baza intențiilor bune. Au nevoie de cantitatea potrivită de apă, livrată la momentul potrivit. Dar să îți amintești cine are nevoie de ce și când? Acolo se luptă majoritatea iubitorilor de plante.",
    },
    // Sistemul Santino
    santinoSystem: {
      subtitle: "Sistemul Santino de îngrijire a plantelor™",
      title: {
        part1: "În inima fiecărui ghiveci Happy Plants se află",
        systemName: "Sistemul Santino de îngrijire a plantelor",
        part2: "— tehnologia noastră de auto-udare caracteristică,",
      },
    },
    // Plante inteligente
    smartPlants: {
      section1: {
        title: "Modalitatea inteligentă de a crește plante fericite",
        text: {
          part1: "Indiferent cine sunteți, începător, entuziast sau profesionist în plante,",
          highlight: "Happy Plants elimină stresul din îngrijirea plantelor.",
        },
      },
      section2: {
        title: "Plantele sunt furnizate cu apă la cerere",
        text: {
          part1: "Cu",
          systemName: "Sistemul Santino de îngrijire a plantelor",
          part2: "în centrul său, ghivecele noastre cu auto-udare rezolvă cele mai comune probleme, astfel încât plantele dvs. să poată prospera și dvs. de asemenea.",
        },
      },
    },
    // Beneficii
    benefits: {
      title: "Cum beneficiază plantele dvs. iubite de ghivecele cu auto-udare ale Sistemului Santino de îngrijire a plantelor?",
      options: {
        twinPot: {
          title: "Ghiveci dublu",
          subtitle: "Două camere lucrând în armonie",
          features: {
            doublePot: {
              title: "Ghiveci dublu de flori",
              text: "ghiveciul exterior și ghiveciul de plantare: facilitează îngrijirea și oferă alte beneficii",
            },
            lessWater: {
              title: "Cu mai puțină apă",
              text: "pentru a monitoriza ușor nivelul apei (pentru ghivece netransparente)",
            },
            hecticSchedule: {
              title: "O soluție excelentă pentru un program agitat",
              text: "bucurați-vă de udare convenabilă fără scurgeri datorită rezervorului de apă interior",
            },
          },
        },
        healthyRoots: {
          title: "Rădăcini sănătoase — Creștere sănătoasă",
          subtitle: "O abordare centrată pe rădăcini care cultivă vitalitatea durabilă din interior.",
          features: {
            moistureProtection: {
              title: "Protecție rădăcini împotriva excesului de umiditate",
              text: "Ghiveciul dublu cu rezervorul de apă sub rădăcinile plantei contribuie la sănătatea rădăcinilor și protejează de stagnarea în apă",
            },
            airCushion: {
              title: "Pernă de aer protectoare",
              text: "ghiveciul dublu creează o pernă de aer care oferă izolație termică care exclude hipotermia sistemului radicular sau uscarea solului",
            },
            soilAeration: {
              title: "Creștere optimă și aerisire sol",
              text: "găurile de drenaj ale ghiveciului interior permit circulația aerului în sol, contribuind astfel la sănătatea plantelor",
            },
          },
        },
        aesthetics: {
          title: "Estetică remarcabilă, design sublim",
          subtitle: "Un ghiveci la fel de frumos ca plantele pe care le susține",
          features: {
            cleanCozy: {
              title: "Curat și confortabil",
              text: "ghiveciul și suprafețele rămân curate: fără vărsături sau urme de murdărie",
            },
            visualControl: {
              title: "Fereastră de control vizual",
              text: "pentru a monitoriza ușor nivelul apei (pentru ghivece netransparente)",
            },
            saucerFree: {
              title: "Fără farfurie",
              text: "bucurați-vă de udare convenabilă fără scurgeri datorită rezervorului de apă interior",
            },
          },
        },
        savingWater: {
          title: "Economisire apă & timp",
          subtitle: "Conceput cu grijă pentru a reduce frecvența udării — mai multă liniște, mai puțin ghicit.",
          features: {
            lessFrequent: {
              title: "Plantele sunt udate mai rar",
              text: "Ghiveciul și suprafețele rămân curate: fără vărsături sau urme de murdărie",
            },
            innerReservoir1: {
              title: "Rezervor interior",
              text: "rezervorul și găurile de drenaj sunt în interiorul ghiveciului, sub nivelul rădăcinilor",
            },
            innerReservoir2: {
              title: "Rezervor interior",
              text: "rezervorul și găurile de drenaj sunt în interiorul ghiveciului, sub nivelul rădăcinilor",
            },
          },
        },
      },
    },
    // Apa este viață
    waterIsLife: {
      title: "Apa este viață, dacă este folosită corect.",
      subtitle: "Despre tehnologia noastră de auto-udare",
      text: {
        paragraph1: "Fiecare plantă are nevoi unice.",
        paragraph2: "Cheia este consistența, nu ghicitul.",
        paragraph3: "Plantele nu prosperă pe baza intențiilor bune — au nevoie de cantitatea potrivită de apă, livrată la momentul potrivit. Dar să îți amintești cine are nevoie de ce și când? Acolo se luptă majoritatea iubitorilor de plante.",
      },
    },
    // Detalii despre apă
    waterDetails: {
      section1: {
        title: "Am reimaginat ghiveciul de flori",
        text: "Plantele sunt furnizate cu apă la cerere – ori de câte ori au nevoie, în cantitatea de care au nevoie.",
      },
      section2: {
        title: "Umiditate constantă. Fără mai mult ghicit.",
        text: 'Ghivecele noastre cu auto-udare sunt proiectate cu un rezervor de apă încorporat la bază. Folosesc acțiunea capilară, cunoscută și sub numele de "mecanism de fitil", pentru a trage apa în sus în sol pe măsură ce planta are nevoie de ea. Acest proces natural asigură că planta dvs. are întotdeauna acces la cantitatea potrivită de umiditate.',
        benefits: {
          noOverwatering: "Fără mai multă udare excesivă",
          noUnderwatering: "Fără mai multă udare insuficientă",
          happyPlants: "Plante fericite cu mai puțin efort",
        },
      },
      section3: {
        title: "Despre tehnologia de auto-udare",
        text: "Fie că sunteți novice în plante sau un grădinar experimentat, sistemul nostru de auto-udare elimină stresul din îngrijirea zilnică a plantelor.",
        features: {
          upgrade: {
            title: "Upgrade-ul",
            text: "Seria noastră Self-Watering+ duce îngrijirea plantelor fără efort la nivelul următor. Fiecare ghiveci din această gamă are fie un sistem de fitil textil, fie o cartuș inovator de drenaj ceramic Seramis® — un material de înaltă performanță dezvoltat în Germania, asigurându-se că plantele dvs. primesc exact cantitatea potrivită de apă.",
          },
          soilMoisture: {
            title: "Umiditate optimă a solului",
            text: "Pe măsură ce rădăcinile plantelor absorb apa din sol, rezervorul încorporat sub ele permite solului să tragă umiditate suplimentară după cum este necesar — menținând umiditatea constantă, optimă pentru o creștere sănătoasă.",
          },
        },
      },
    },
    // Magazin apă
    shopWater: {
      cards: {
        selfWatering: {
          title: "Auto-udare",
          text: "Fie că sunteți novice în plante sau un grădinar experimentat, sistemul nostru de auto-udare elimină stresul din îngrijirea zilnică a plantelor.",
        },
        selfWateringPlus1: {
          title: "Auto-udare+",
          text: "Ghiveci dublu cu fitil pentru umiditate optimă a solului. Conceput pentru iubitorii de orhidee",
        },
        selfWateringPlus2: {
          title: "Auto-udare+",
          text: "Ghiveci dublu cu cartuș de granule vegetale SERAMIS® pentru reținere ridicată a apei și nutrienților.",
        },
      },
      shopNow: "Cumpără acum",
    },
    // Mai multe de explorat
    moreExplore: {
      title: "Mai multe de explorat",
      subtitle: "Alăturați-vă sutelor de profesioniști din întreaga lume care au încredere deja în Happy Plants.",
      cards: {
        shopNew: {
          title: "Cumpărați modele noi",
          text: "Descoperiți cele mai recente jardiniere cu auto-udare și designuri moderne de ghivece create pentru a se potrivi fiecărei case, birou și spațiu de afaceri.",
          button: "Cumpără acum",
        },
        aboutSystem: {
          title: "Despre sistemul de auto-udare",
          text: "Tehnologia noastră inovatoare de auto-udare menține plantele perfect hidratate pentru o perioadă lungă.",
          button: "Explorați",
        },
        plantsCare: {
          title: "Sistem de îngrijire a plantelor",
          text: "Happy Plants contribuie la sănătatea plantelor prin design: aerare, echilibru al umidității și drenaj corespunzător",
          button: "Explorați",
        },
        sustainability: {
          title: "Sustenabilitate",
          text: "Toate produsele Happy Plants sunt fabricate din materiale reciclabile, ajutând la reducerea deșeurilor de plastic și susținând o economie circulară.",
          button: "Explorați",
        },
      },
    },
  },

  // Pagina colecție
  collection: {
    header: {
      title: "Descoperiți gama noastră de produse",
      titleWithCategory: "Colecție",
      subtitle: "Fiecare ghiveci, creat unic. Proiectat cu grijă, conceput cu atenție — fiecare făcut pentru a ajuta plantele dvs. (și pe dvs.) să prosperați.",
      breadcrumbs: {
        home: "Acasă",
        allCollections: "Toate colecțiile",
      },
    },

    filters: {
      search: "Căutare",
      appliedFilters: "Filtre aplicate:",
      total: "Total:",
      products: "Produse",
      advicesAndTips: "Sfaturi și consiliere",
      sortBy: "Sortează după",
      sortOptions: {
        priceLowHigh: "Preț de la 0-100",
        priceHighLow: "Preț de la 100-0",
        nameAZ: "Nume A-Z",
        nameZA: "Nume Z-A",
      },
      filtersTitle: "Filtre",

      filterTypes: {
        potSize: "Dimensiune ghiveci",
        potType: "Tip ghiveci",
        potShape: "Formă ghiveci",
        exteriorColor: "Culoare exterioară",
        functionality: "Funcționalitate",
      },

      functionality: {
        waterControl: "Fereastră de control apă",
        bottomPlug: "Dop inferior pentru drenaj",
        indoor: "Pentru interior",
        outdoor: "Pentru exterior",
        semiTransparent: "Semi-transparent",
        orchids: "Pentru orhidee",
        windowBox: "Jardinieră fereastră",
      },

      loading: "Se încarcă produsele...",
      noResults: "Nu s-au găsit produse",
      clearFilters: "Șterge filtrele",
      loadMore: "Încarcă mai mult",
      retry: "Reîncearcă",
    },

    recentlyViewed: {
      title: "Ați vizualizat recent",
      subtitle: "Sortiment revizuit recent de dvs.",
    },
  },

  // Pagina produs
  product: {
    breadcrumbs: {
      home: "Acasă",
      allCollections: "Toate colecțiile",
    },

    details: {
      skuNumber: "Nr. SKU",
      readFullDescription: "Citiți descrierea completă",
      potType: "Tip ghiveci",
      potShape: "Formă ghiveci",
      dimensions: "Dimensiuni (cm)",
      availableColors: "Culori exterioare disponibile",
      addToCart: "Adaugă în coș",

      quantity: {
        label: "Cantitate",
      },

      messages: {
        addedToCart: "Produs adăugat cu succes în coș!",
      },

      payment: {
        title: "Plățile online vin în curând.",
        description: "Cu toate acestea, puteți plasa în continuare o cerere de comandă prin intermediul site-ului web. Odată ce cererea dvs. este trimisă, un manager de vânzări vă va contacta în curând pentru a confirma detaliile și a aranja plata. Aflați mai multe în",
        link: "Plasarea comenzii și livrarea",
      },
    },

    description: {
      title: "Descrierea produsului",
      dimensionsTitle: "Dimensiuni produs",
      faqTitle: "Întrebările dvs., răspunse",

      faq: {
        question1: {
          title: "Nu este greu să ai grijă de orhidee?",
          text: "Nu cu sistemul nostru de auto-udare — menține rădăcinile hidratate la nivelul potrivit fără udare zilnică.",
        },
        question2: {
          title: "Se va potrivi ghiveciul cu interiorul meu?",
          text: "Absolut — fiecare ghiveci Arte-Dea este proiectat cu linii curate, elegante care completează orice spațiu.",
        },
        question3: {
          title: "Ce se întâmplă dacă uit să-l ud?",
          text: "Fără griji — rezervorul încorporat oferă orhideei dvs. o aprovizionare constantă cu umiditate timp de zile, astfel încât planta dvs. să rămână sănătoasă chiar dacă sunteți ocupat.",
        },
      },
    },

    otherProducts: {
      title_part_1: "Mai multe din",
      title_part_2: "Colecție",
      subtitle: "Căutați un stil asortant? Explorați alte piese din aceeași colecție mai jos.",
    },
  },

  // Pagina Principii
  principles: {
    breadcrumbs: {
      home: "Acasă",
      principles: "Principii de îngrijire a plantelor",
    },

    header: {
      title: "Principii de îngrijire a plantelor",
      subtitle: "Ajutând pe cei care au grijă de plante. Ghiduri blânde pentru grădinari și iubitori de plante.",
    },

    forWhom: {
      title: "Pentru cine sunt ghivecele Happy Plants?",
      subtitle: "Cinci tipuri de iubitori de plante și grădinari care înfloresc cu ghivecele și îngrijirea noastră",
      types: {
        newParents: "Părinți noi de plante",
        experienced: "Grădinari experimentați",
        indoor: "Entuziaști ai stilului de viață interior",
        lovers: "Iubitori de flori și plante",
        gifters: "Cumpărători de cadouri",
      },
    },

    sevenPrinciples: {
      mainTitle: "Principiile Santino pentru plante sănătoase",
      mainSubtitle: "Livrarea de produse de îngrijire a plantelor de înaltă calitate încercând concepte noi",
      shopButton: "Cumpără toate ghivecele",
      bottomTitle: "Pentru implementarea tuturor celor 7 principii de îngrijire a plantelor, am proiectat ghivece de flori excepționale",

      principles: {
        alive: {
          title: "Plantele sunt vii",
          text: 'O plantă este un organism viu — crește, respiră, transpiră și necesită apă, nutrienți, lumină, mediul potrivit și temperatura adecvată. De asemenea, trebuie să fie replantată, se poate reproduce și — ca și noi — poate prospera sau suferi, se poate simți "fericit" sau poate prezenta semne de suferință.',
        },
        unique: {
          title: "Fiecare plantă este unică",
          text: "Fiecare plantă este unică, dar fiecare are nevoie de condițiile potrivite pentru creștere și protecție. Aceasta include o rutină personalizată de îngrijire: udare, fertilizare, tratament și monitorizare a sănătății — toate în conformitate cu propriul său ritm natural.",
        },
        soil: {
          title: "Folosiți solul potrivit",
          text: "Folosiți un mediu de plantare adecvat — sol adecvat, material de drenaj, unelte și îngrășăminte adaptate nevoilor specifice ale plantei dvs.",
        },
        pot: {
          title: "Alegeți ghiveciul potrivit",
          text: "Alegeți ghiveciul potrivit — dimensiunea, forma, funcționalitatea și chiar culoarea pot afecta bunăstarea unei plante.",
        },
        water: {
          title: "Nu udați excesiv",
          text: "Majoritatea plantelor nu plac excesul de umiditate. Udarea excesivă poate provoca putrezirea rădăcinilor, în special la speciile non-hidrofile. Asigurați un drenaj adecvat, în special pentru ghivecele de exterior, pentru a menține rădăcinile sănătoase.",
        },
        heat: {
          title: "Evitați stresul termic",
          text: "Plantele sunt vulnerabile la stresul termic. Temperaturile extreme — prea calde sau prea reci — pot deshidrata solul, apa și aerul din jurul plantei, împiedicând creșterea și dezvoltarea acesteia.",
        },
        love: {
          title: "Iubiți-vă plantele",
          text: "Admirați și iubiți-vă plantele! Acordați-le atenție, îngrijire și răbdare. În schimb, vă vor răsplăti cu frumusețe, vitalitate și un sentiment profund de bucurie și împlinire.",
        },
      },
    },

    gradient: {
      selfWatering: {
        title: "Auto-udare pentru umiditate constantă",
        text: "Ghivecele Happy Plants au un rezervor de apă încorporat și un sistem de fitil capilar care livrează apă solului după cum este necesar. Acest rezervor inteligent elimină ghicitul și previne atât udarea excesivă, cât și insuficientă",
      },
      healthyRoots: {
        title: "Rădăcini sănătoase datorită aerisirii optime",
        text: "Designul ghiveciului dublu creează o pernă de aer în jurul zonei rădăcinilor. Găurile de drenaj și un rezervor interior protejează rădăcinile de apa stagnantă și putrezire, asigurându-se în același timp că primesc aer proaspăt",
      },
      cleanDesign: {
        title: "Design curat, care economisește timp și conservă apa",
        text: "Aceste ghivece sunt fără farfurie și au o fereastră pentru verificarea nivelului apei, menținând suprafețele curate și evitând petele de apă.",
      },
    },

    callToAction: {
      title: "Gata să vă faceți plantele mai fericite?",
      text: "Explorați gama noastră completă de ghivece Happy Plants cu auto-udare și oferiți prietenilor dvs. verzi îngrijirea pe care o merită.",
      button: "Cumpără toate ghivecele",
    },
  },

  // Pagina Plants Care System
  plantsCareSystem: {
    breadcrumbs: {
      home: "Acasă",
      system: "Sistem de îngrijire a plantelor",
    },

    header: {
      title: "Sistem de îngrijire a plantelor",
      subtitle: "Inteligent. Stilat. Făcut pentru viața reală",
    },

    heart: {
      title: "În inima fiecărui ghiveci Happy Plants",
      text: "Sistemul Santino de îngrijire a plantelor — este tehnologia noastră caracteristică de auto-udare, care reunește toate caracteristicile Happy Plants proiectate pentru a menține plantele sănătoase și iubitorii de plante fericiți.",
      button: "Cumpără ghivece de îngrijire a plantelor",
    },

    allInOne: {
      title: "Soluție de îngrijire all-in-one",
      text: "Sistemul Santino de îngrijire a plantelor™ reunește toate caracteristicile Happy Plants™ proiectate pentru a menține plantele sănătoase și iubitorii de plante fericiți.",
      button: "Cumpără acum",

      features: {
        feature1: "Părinți noi de plante",
        feature2: "Sistem integrat de auto-udare pentru hidratare constantă, consistentă",
        feature3: "Indicator vizibil al nivelului apei — niciodată să nu mai udați excesiv sau insuficient",
        feature4: "Flux de aer îmbunătățit pentru a proteja rădăcinile și a preveni putrezirea",
        feature5: "Design cu întreținere redusă perfect pentru viața modernă, ocupată",
      },
    },

    selfWatering: {
      title: "Tehnologia de auto-udare ca parte a sistemului de îngrijire a plantelor",
      subtitle: "Fie că sunteți novice în plante sau un grădinar experimentat, sistemul nostru de auto-udare elimină stresul din îngrijirea zilnică a plantelor.",
      button: "Explorați auto-udarea",

      upgrade: {
        title: "Upgrade-ul",
        text: "Seria noastră Self-Watering+ duce îngrijirea plantelor fără efort la nivelul următor. Fiecare ghiveci din această gamă are fie un sistem de fitil textil, fie un cartuș inovator de drenaj ceramic Seramis® — un material de înaltă performanță dezvoltat în Germania, asigurându-se că plantele dvs. primesc exact cantitatea potrivită de apă.",
      },

      moisture: {
        title: "Umiditate optimă a solului",
        text: "Pe măsură ce rădăcinile plantelor absorb apa din sol, rezervorul încorporat sub ele permite solului să tragă umiditate suplimentară după cum este necesar — menținând umiditatea constantă, optimă pentru o creștere sănătoasă.",
      },
    },
  },

  // Pagina Sustainability
  sustainability: {
    breadcrumbs: {
      home: "Acasă",
      sustainability: "Sustenabilitate",
    },

    intro: {
      title: "Fiecare transformare mare începe cu un pas simplu",
      paragraph1: "La Happy Plants, credem că fiecare ghiveci de flori are o poveste și că acea poveste nu trebuie să se termine când ghiveciul se crăpă, se decolorează sau nu mai este necesar.",
      paragraph2: "Prin CycleBloom, procesul nostru intern de reciclare, oferim ghivecelor folosite o a doua viață, transformând materialele de ieri în designurile frumoase, funcționale de mâine.",
      paragraph3: "Este modul nostru de a proteja natura, de a reduce deșeurile și de a construi un viitor în care sustenabilitatea și stilul merg mână în mână.",
    },

    process: {
      step1: {
        title: "Colectare, recuperare și sortare după culoare",
        text: "Începem prin a aduna și sorta după culoare ghivecele de flori folosite sau deteriorate de la clienți, comercianți, din producție și parteneri. Acestea sunt recuperate și pregătite pentru o nouă viață în loc să ajungă în gropile de gunoi.",
      },
      step2: {
        title: "Mărunțire și zdrobire",
        text: "Ghivecele sortate sunt apoi mărunțite în fulgi mici, uniformi — până la 10 mm în dimensiune. Acești fulgi sunt ideali pentru prelucrarea ulterioară și comportamentul de topire constant în timpul modelării.",
      },
      step3: {
        title: "Ambalare și depozitare",
        text: "Materialul zdrobit este depozitat în saci industriali mari, menținând fiecare lot de culoare curat și organizat până când este timpul pentru producție.",
      },
      step4: {
        title: "Modelarea în ghivece noi",
        text: "Folosind mașini tradiționale de modelare termoplastică, transformăm materialul reciclat în ghivece de flori complet noi. Nu se adaugă material virgin — se folosește PP 100% reciclat.",
      },
    },

    result: {
      title: "Rezultatul?",
      paragraph1: "O nouă generație de ghivece de flori: puternice, elegante și durabile. Fiecare este fabricat în întregime din material reciclat și este complet reciclabil din nou.",
      paragraph2: "Este mai mult decât un simplu ghiveci — este parte dintr-un viitor circular în care frumusețea întâlnește responsabilitatea.",
    },
  },

  // Pagina Self-Watering System
  selfWateringSystem: {
    breadcrumbs: {
      home: "Acasă",
      selfWatering: "Sistem de auto-udare",
    },

    header: {
      title: "Sistem de auto-udare",
      subtitle: "Inteligent. Stilat. Făcut pentru viața reală",
    },

    whatIs: {
      title: "Ce este auto-udarea?",
      text: 'Mulți iubitori de plante se confruntă cu această problemă: cum să asigure un nivel constant de umiditate pentru fiecare companion verde. Plantele nu trăiesc „după noroc” — au nevoie de o cantitate stabilă de apă la momentul potrivit. Dar este greu să-ți amintești când și câtă apă are nevoie fiecare ghiveci. De aceea am reinventat ghiveciul: ghiveciul nostru Happy Plants cu sistem de auto-udare elimină presupunerile și face îngrijirea mai ușoară.',
      button: "Explorați",
    },

    allInOne: {
      title: "Această soluție de îngrijire all-in-one",
      text: 'Caracteristica cheie a auto-udării este un rezervor de apă încorporat la bază. Printr-un sistem capilar asemănător unui fitil, apa urcă treptat către rădăcini, furnizând plantelor umiditate "la cerere".',
      features: {
        feature1: "Umiditate constantă, fără presupuneri. Rezervorul interior mare oferă un aport constant de apă.",
        feature2: "Protecție rădăcini. Structura cu perete dublu creează o pernă de aer care previne putrezirea rădăcinilor și hipotermia.",
        feature3: "Mai puține udări. Rezervorul interior menține planta hidratată pentru o lungă perioadă.",
        feature4: "Curat și convenabil. Ghivecele nu au nevoie de farfurii și includ o fereastră mică pentru verificarea nivelurilor de apă (pentru modelele opace).",
        feature5: "Design cu întreținere redusă perfect pentru viața modernă, ocupată",
      },
      button: "Cumpără acum",
    },

    reimagined: {
      title: "Am reimaginat ghiveciul de flori",
      text: "Plantele sunt furnizate cu apă la cerere – ori de câte ori au nevoie, în cantitatea de care au nevoie.",
    },

    consistentMoisture: {
      title: "Umiditate constantă. Fără mai mult ghicit.",
      text: 'Ghivecele noastre cu auto-udare sunt concepute cu un rezervor de apă integrat la bază. Ele folosesc acțiunea capilară, cunoscută și sub numele de „fitil”, pentru a trage apa în sus în sol, prin găurile de drenaj ale ghiveciului interior, pe măsură ce planta are nevoie. Acest proces natural asigură că planta ta are întotdeauna acces la cantitatea potrivită de umiditate. Al doilea avantaj este aerarea solului, care sprijină rădăcinile și sănătatea generală a plantei.',
      benefits: {
        noOverwatering: "Fără mai multă udare excesivă",
        noUnderwatering: "Fără mai multă udare insuficientă",
        happyPlants: "Plante fericite cu mai puțin efort",
      },
    },
  },

  // Pagina Hashtag
  hashtag: {
    breadcrumbs: {
      home: "Acasă",
      hashtag: "Hashtag #",
    },

    header: {
      description: "Iată tot ce puteți găsi despre",
      byHappyPlants: "de HappyPlants",
    },

    relevantProducts: {
      title: "Produse relevante",
      subtitle: "Explorați produsele relevante pentru #",
    },

    relevantArticles: {
      title: "Articole relevante",
      subtitle: "Explorați articolele relevante pentru #",
    },
  },

  // Pagina Contact Us
  contactUs: {
    header: {
      title: "Contact",
      subtitle: "La HappyPlants, satisfacția dvs. este prioritatea noastră. Dacă aveți nevoie de ceva, suntem întotdeauna aici pentru a ajuta.",
    },

    sections: {
      headOffice: "Sediu central",
      phone: "Telefon",
      email: "Email",
      companyDetails: "Detalii companie",
    },

    form: {
      firstName: {
        label: "Prenume",
        placeholder: "Nume",
      },
      lastName: {
        label: "Nume de familie",
        placeholder: "Nume de familie",
      },
      email: {
        label: "Email-ul dvs.",
        placeholder: "Email",
      },
      phone: {
        label: "Telefon (opțional)",
        placeholder: "+373 XX XXX XXX",
      },
      topic: {
        label: "Subiect",
        placeholder: "Selectați o opțiune",
      },
      message: {
        label: "Mesajul dvs.",
        placeholder: "Scrieți mesajul dvs. aici",
      },
      submitButton: "Trimite!",
    },

    validation: {
      required: "Acest câmp este obligatoriu",
      invalidEmail: "Adresă de email invalidă",
    },

    messages: {
      success: "Mesajul dvs. a fost trimis cu succes!",
      error: "A apărut o eroare. Vă rugăm să încercați din nou.",
    },

    defaultTopics: {
      general: "Întrebare generală",
      partnership: "Parteneriat",
      pricing: "Prețuri",
      other: "Altele",
    },
  },

  // Pagina Blog
  blog: {
    breadcrumbs: {
      home: "Acasă",
      blog: "Blog Happy Plants",
    },

    header: {
      title: "Blog Happy Plants",
      subtitle: "Perspective, sfaturi și inspirație pentru iubitorii de plante",
    },
  },

  // Pagina About Us & B2B
  aboutB2B: {
    breadcrumbs: {
      home: "Acasă",
      aboutB2B: "Despre noi & Cooperare B2B",
    },

    header: {
      title: "Despre noi & Cooperare B2B",
      subtitle: "Oferind ghivecelor de flori o nouă viață.",
    },

    weAre: {
      title: "Suntem Happy Plants",
      subtitle: "un producător european de jardiniere cu auto-udare gata pentru retail, cu o experiență dovedită în livrarea de produse cu marjă ridicată și rulaj rapid către mari comercianți cu amănuntul și distribuitori din întreaga lume.",
    },

    customersWant: {
      title: "Clienții dvs. vor mai mult decât simple ghivece de flori.",
      text: "Vor confort, eleganță și soluții care economisesc timp și apă — și noi facem asta posibil.",
    },

    whyWorkWithUs: {
      title: "De ce să lucrați cu noi",
      features: {
        provenSeller: "Vânzător dovedit — Jardinierele noastre cu auto-udare performează deja cu succes pe piețele de retail din SUA și UE, atât sub marca noastră, cât și ca marcă proprie.",
        retailReady: "Gata pentru retail — Fiecare produs vine ambalat, cu cod de bare și gata pentru rafturile dvs.",
        designThatSells: "Design care vinde — Designuri atractive, funcționale stimulează achizițiile impulsive și vânzările repetate.",
        cleanConvenient: "Curat și convenabil. Ghivecele nu au nevoie de farfurii și includ o fereastră mică pentru verificarea nivelurilor de apă (pentru modelele opace).",
        highProfitMargins: "Marje de profit ridicate — Construcție suprapusă, care economisește spațiu, înseamnă costuri de expediere și depozitare mai mici, stimulând profitul dvs.",
      },
      button: "Cumpără acum",
    },

    ourEdge: {
      title: "Avantajul nostru",
      features: {
        fullCycle: "Producție cu ciclu complet — De la designul conceptual până la ambalarea finală, totul în fabrica noastră din Moldova.",
        capacity: "Capacitate pe care vă puteți baza — 150.000 de jardiniere pe lună, calitate constantă și livrări la timp.",
        designSells: "Design care vinde — Designuri atractive, funcționale stimulează achizițiile impulsive și vânzările repetate.",
        ecoResponsible: "Responsabil ecologic — Folosim atât plastic reciclat, cât și virgin, atingând obiectivele de sustenabilitate fără a compromite calitatea.",
        logistics: "Logistică fără dureri de cap — Livrare DDP/DDU în SUA în 40 de zile; parteneri de transport stabiliți, de încredere.",
      },
      button: "Cumpără acum",
    },

    productsFit: {
      title: "Produse care se potrivesc pieței dvs.",
      features: {
        indoorOutdoor: "Jardiniere cu auto-udare pentru interior și exterior",
        orchidPots: "Ghivece premium pentru orhidee cu fitil absorbant de apă",
        decorativeOptions: "Modele cu suporturi și opțiuni decorative",
        multipleOptions: "Multiple forme, dimensiuni și culori — gata pentru marca dvs. proprie",
      },
      button: "Cumpără acum",
    },

    opportunity: {
      title: "Oportunitatea",
      paragraph1: 'Ajutăm comercianții cu amănuntul să crească rulajul categoriei și să extindă segmentul în creștere al "grădinăritului convenabil" cu jardiniere gata de stocat, gata de vânzare.',
      paragraph2: "Fie că doriți să vă extindeți sortimentul de grădinărit, să lansați o promoție sezonieră sau să creați o linie exclusivă de marcă proprie — avem aprovizionarea, calitatea și experiența pentru a livra.",
    },

    contactForm: {
      title: "Să discutăm despre obiectivele dvs. de sortiment.",
      contact: {
        title: "Contact",
      },
      sections: {
        headOffice: "Sediu central",
        phone: "Telefon",
        email: "Email",
      },
      form: {
        firstName: {
          label: "Prenume",
          placeholder: "Nume",
        },
        lastName: {
          label: "Nume de familie",
          placeholder: "Nume de familie",
        },
        email: {
          label: "Email-ul dvs.",
          placeholder: "Email",
        },
        phone: {
          label: "Telefon (opțional)",
          placeholder: "+373 XX XXX XXX",
        },
        topic: {
          label: "Subiect",
          placeholder: "Selectați o opțiune",
        },
        message: {
          label: "Mesajul dvs.",
          placeholder: "Scrieți mesajul dvs. aici",
        },
        submitButton: "Trimite!",
      },
      validation: {
        required: "Acest câmp este obligatoriu",
        invalidEmail: "Adresă de email invalidă",
      },
      messages: {
        success: "Mesajul dvs. a fost trimis cu succes!",
        error: "A apărut o eroare. Vă rugăm să încercați din nou.",
      },
      defaultTopics: {
        general: "Întrebare generală",
        partnership: "Parteneriat",
        pricing: "Prețuri",
        other: "Altele",
      },
    },
  },

  // Pagina articol blog
  blogArticle: {
    breadcrumbs: {
      home: "Acasă",
      blog: "Blog Happy Plants",
    },
    title: "Blog Happy Plants",
    subtitle: "Perspective, sfaturi și inspirație pentru iubitorii de plante",
  },

  // Componenta Explore Hashtags
  exploreHashtags: {
    title: "Explorați mai multe hashtag-uri Happy Plants",
  },

  // Pagina coș de cumpărături
  shoppingCartPage: {
    title: "Coșul dvs. de cumpărături",
    subtitle: "Odată ce primim cererea dvs., managerul nostru va verifica disponibilitatea și vă va contacta pentru a confirma detaliile și a finaliza comanda.",
    emptyCart: "Coșul dvs. este gol",
    loading: "Se încarcă coșul dvs...",

    volumeSize: "Volum + Dimensiune",
    color: "Culoare",

    quantity: "Cantitate",
    pot: "ghiveci",
    pots: "ghivece",

    checkout: {
      title: "Finalizare",
      subtotalProducts: "Subtotal produse:",
      volume: "Volum",
      minimumOrder: "Suma minimă a comenzii este EUR",
      currently: "în prezent EUR",
      minimumOrderWarning: "Suma minimă a comenzii este",
      termsAgreement: 'Făcând clic pe "Plasează comanda", confirmați că ați citit termenii de livrare și sunteți de acord cu Termenii și condițiile noastre.',
      placeOrder: "Plasează comanda",
    },

    paymentInfo: {
      title: "Plățile online vin în curând.",
      text: "Cu toate acestea, puteți plasa în continuare o cerere de comandă prin intermediul site-ului web. Odată ce cererea dvs. este trimisă, un manager de vânzări vă va contacta în curând pentru a confirma detaliile și a aranja plata. Aflați mai multe în Plasarea comenzii și livrarea.",
    },

    removeConfirm: "Sunteți sigur că doriți să eliminați acest articol din coșul dvs.?",
  },

  // Formular finalizare
  checkoutForm: {
    title: "Finalizare",
    billingAddress: "Adresă de facturare:",
    billingAddressText: "Folosită pentru plată și facturare. Trebuie să corespundă detaliilor cardului sau metodei de plată.",
    shippingAddress: "Adresă de livrare:",
    shippingAddressText: "Unde va fi livrată comanda dvs. Puteți folosi o adresă diferită de cea de facturare dacă este necesar.",

    emptyCart: "Coșul dvs. este gol",

    minimumOrderWarning: "Suma minimă a comenzii este EUR",
    currentTotal: "Total curent: EUR",

    placeOrder: "Plasează comanda",
    creatingOrder: "Se creează comanda...",

    unexpectedError: "A apărut o eroare neașteptată. Vă rugăm să încercați din nou.",

    orderSummary: {
      title: "Rezumat comandă",
      productsTotal: "Total produse:",
      items: "Articole:",
      item: "articol",
      itemsPlural: "articole",
      shippingCost: "Cost livrare",
      willBeInformed: "Veți fi informat după plasarea comenzii",
      orderDetails: "Detalii comandă:",
    },

    paymentInfo: {
      title: "Plățile online vin în curând.",
      text: "Cu toate acestea, puteți plasa în continuare o cerere de comandă prin intermediul site-ului web. Odată ce cererea dvs. este trimisă, un manager de vânzări vă va contacta în curând pentru a confirma detaliile și a aranja plata. Aflați mai multe în Plasarea comenzii și livrarea.",
    },
  },

  // Formular adresă livrare
  deliveryAddressForm: {
    title: "Adresă de livrare",

    fields: {
      email: "*Email",
      emailPlaceholder: "Email",
      name: "*Nume",
      namePlaceholder: "Nume",
      surname: "*Prenume",
      surnamePlaceholder: "Prenume",
      businessName: "Nume companie",
      businessNamePlaceholder: "Nume companie",
      addressLine1: "Adresa linia 1",
      addressLine1Placeholder: "Adresa linia 1",
      addressLine2: "Adresa linia 2",
      addressLine2Placeholder: "Adresa linia 2",
      zipCode: "*Cod poștal",
      zipCodePlaceholder: "Cod poștal",
      city: "*Oraș",
      cityPlaceholder: "Oraș",
      province: "*Județ",
      provincePlaceholder: "Județ",
      country: "*Țară",
      countryPlaceholder: "Selectați țara",
      noteToCarrier: "Notă pentru curier",
      noteToCarrierPlaceholder: "Notă pentru curier",
      phoneNumber: "*Număr telefon",
      phoneNumberPlaceholder: "+40 78 580 4972",
    },

    validation: {
      emailRequired: "Email-ul este obligatoriu",
      emailInvalid: "Email-ul trebuie să fie valid",
      fieldRequired: "Câmpul este obligatoriu",
      minCharacters: "Minim 2 caractere",
      phoneRequired: "Numărul de telefon este obligatoriu",
      phoneInvalid: "Număr de telefon invalid",
      zipRequired: "Codul poștal este obligatoriu",
      zipInvalid: "Cod poștal invalid",
    },

    save: "Salvează",
    changeAddress: "Schimbă adresa",
    loadingCountries: "Se încarcă țările...",
    noCountries: "Nu sunt țări disponibile",
  },

  // Formular adresă facturare
  invoiceAddressForm: {
    title: "Adresă de facturare",
    useSameAddress: "Folosiți aceeași adresă ca pentru livrare",

    fields: {
      email: "*Email",
      emailPlaceholder: "Email",
      name: "*Nume",
      namePlaceholder: "Nume",
      surname: "*Prenume",
      surnamePlaceholder: "Prenume",
      businessName: "Nume companie",
      businessNamePlaceholder: "Nume companie",
      addressLine1: "Adresa linia 1",
      addressLine1Placeholder: "Adresa linia 1",
      addressLine2: "Adresa linia 2",
      addressLine2Placeholder: "Adresa linia 2",
      zipCode: "*Cod poștal",
      zipCodePlaceholder: "Cod poștal",
      city: "*Oraș",
      cityPlaceholder: "Oraș",
      province: "*Județ",
      provincePlaceholder: "Județ",
      country: "*Țară",
      countryPlaceholder: "Selectați țara",
      noteToCarrier: "Notă pentru curier",
      noteToCarrierPlaceholder: "Notă pentru curier",
      phoneNumber: "*Număr telefon",
      phoneNumberPlaceholder: "+40 78 580 4972",
    },

    validation: {
      emailRequired: "Email-ul este obligatoriu",
      emailInvalid: "Email-ul trebuie să fie valid",
      fieldRequired: "Câmpul este obligatoriu",
      minCharacters: "Minim 2 caractere",
      phoneRequired: "Numărul de telefon este obligatoriu",
      phoneInvalid: "Număr de telefon invalid",
      zipRequired: "Codul poștal este obligatoriu",
      zipInvalid: "Cod poștal invalid",
    },

    save: "Salvează",
    changeAddress: "Schimbă adresa",
    loadingCountries: "Se încarcă țările...",
    noCountries: "Nu sunt țări",
  },

  // Confirmare comandă
  orderConfirmation: {
    thankYou: "Mulțumim,",
    subtitle: "Plantele dvs. vor fi mai fericite ca niciodată",
    emailSent: "V-am trimis factura și informațiile comenzii pe email",
    here: "aici",

    productsTotal: "Total produse:",
    items: "Articole:",
    itemsCount: "articole",
    orderId: "ID comandă:",

    continueShopping: "Continuați cumpărăturile",
    downloadInvoiceButton: "Descărcați factura",
  },

  // Detalii comandă
  orderDetails: {
    title: "Detalii comandă:",
    volumeSize: "Volum + Dimensiune",
    color: "Culoare",
    productImage: "Imagine produs",
    product: "Produs",
  },

  // Componenta Tips & Ideas
  tipsIdeas: {
    title: "Sfaturi, idei și inspirație",
    subtitle: "Explorați îngrijirea inteligentă a plantelor, designul sustenabil și cele mai bune modalități de a profita la maximum de ghivecele dvs. Happy Plants.",
    readNow: "Citiți acum",
    hashtagsTitle: "Hashtag-uri",
    hashtagsText: "Folosiți hashtag-urile pentru a găsi instantaneu produse, articole și inspirație conexe. Un clic vă conectează la tot ce contează.",
  },

  // Footer
  footer: {
    site: "Site",
    shopHappyPlants: "Magazin Happy Plants",
    clientServiceTitle: "Serviciu clienți",
    menu: {
      home: "Acasă",
      shop: "Magazin",
      sustainability: "Sustenabilitate",
      selfWatering: "Auto-udare",
      careSystem: "Sistem de îngrijire",
      blog: "Blog",
      about: "Despre noi & B2B",
    },
    clientService: {
      contact: "Contactați-ne",
      shipping: "Livrare",
      terms: "Termeni de plasare a comenzii",
      privacy: "Confidențialitate",
      retailer: "Deveniți comerciant",
    },
    legal: {
      terms: "Termeni și condiții",
      imprint: "Informații legale",
      cookies: "Cookie-uri",
      privacy: "Politica de confidențialitate",
    },
    copyright: "&copy; Happy Plants™ 2025",
    developedBy: "Design web și dezvoltare de Amark.pro",
  },

  // Texte comune
  common: {
    readNow: "Citiți acum",
    readMore: "Citiți mai mult",
    learnMore: "Aflați mai multe",
    buyNow: "Cumpără acum",
    addToCart: "Adaugă în coș",
    shop: "Magazin",
    shopNow: "Cumpără acum",
    explore: "Explorați",
  },
};